import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideWhyNow() {
  return <Slide data-id="element-325">
      <SlideHeader data-id="element-326">Why Now</SlideHeader>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-327">
        <div className="lg:col-span-7" data-id="element-328">
          <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl lg:text-[90px] font-serif leading-[1.05] tracking-tight mb-8" data-id="element-329">
            Atlassian bought DX for $1B.
          </motion.h2>
          <motion.p variants={itemVariants} className="text-2xl md:text-3xl text-gray-400 font-light" data-id="element-330">
            Enterprise wants the independent alternative.
          </motion.p>
        </div>

        <motion.div variants={itemVariants} className="lg:col-span-4 lg:col-start-9 space-y-12" data-id="element-331">
          <div className="border-l border-white pl-6" data-id="element-332">
            <h3 className="text-xl font-medium mb-2" data-id="element-333">AI Tool Explosion</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-334">
              Teams are adopting Copilot, Cursor, Devin, and Claude Code
              simultaneously. Fragmentation is at an all-time high.
            </p>
          </div>

          <div className="border-l border-white pl-6" data-id="element-335">
            <h3 className="text-xl font-medium mb-2" data-id="element-336">The CFO Mandate</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-337">
              Finance is demanding ROI justification for massive AI licensing
              costs. Engineering leaders have no data to provide.
            </p>
          </div>

          <div className="border-l border-white pl-6" data-id="element-338">
            <h3 className="text-xl font-medium mb-2" data-id="element-339">No System of Record</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-340">
              Existing DevEx tools measure human output. None are built to
              measure, orchestrate, or learn from autonomous agents.
            </p>
          </div>

          <div className="border-l border-white pl-6" data-id="element-341">
            <h3 className="text-xl font-medium mb-2" data-id="element-342">
              RL Loops Become Default
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-343">
              Every company will need RL loops in their agents. Without them,
              prompting stays an expert skill — and accuracy plateaus.
            </p>
          </div>
        </motion.div>
      </div>
    </Slide>;
}